import React, { Component, Suspense, lazy } from "react";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import { AmplifyTheme } from "aws-amplify-react";

import { Auth } from "aws-amplify";
// import { LoginPage } from "components/CustomAuth/Login";

import AWSAppSyncClient from "aws-appsync";
import { ApolloProvider } from "react-apollo";
import { Rehydrated } from "aws-appsync-react";
import config from "./aws-exports";
import ProviderContext from "./data/contextData";
import { getCustomer } from "./graphql/queries";
import gql from "graphql-tag";
//pages
import RegistrationForm from "./pages/RegistrationPage";
import LoginPage from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import CustomerRegistrationForm from "./pages/CustomerRegistrationPage";
import VendorRegForm from "./pages/RegVendor";
import TireVendorRegForm from "./pages/RegTireVendor";
import Portal from "./pages/PortalPage";
import NavbarApp from "./pages/Navbar";
import ConfirmSignUp from "./pages/ConfirmSignUp";
import ConfirmSignUp2 from "./pages/confirmSignUp2";
import CustomerDashboard from "./pages/DashboardCustomer";
import VehicleTypeForm from "./pages/VehicleTypeForm";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Trainings from "./pages/Trainings";
import IntroToDot from "./pages/IntrotoDOT";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Spinner } from "@chevtek/react-spinners";
import loadingImg from "./images/loading.gif";

import { connect } from "react-redux";
import * as actionTypes from "./redux/actions";

import Dashboard from "./layouts/Dashboard/Dashboard.jsx";
import DashboardAdmin from "./layouts/Dashboard/DashboardAdmin.jsx";
import DashboardInspector from "./layouts/Dashboard/DashboardInspector.jsx";
import DashboardVendor from "./layouts/Dashboard/DashboardVendor.jsx";
import DashboardTireVendor from "./layouts/Dashboard/DashboardTireVendor.jsx";
import DashboardDispatcher from "./layouts/Dashboard/DashboardDispatcher.jsx";
import DashboardTechnician from "./layouts/Dashboard/DashboardTechnicians.jsx";
import DashboardMechanic from "./layouts/Dashboard/DashbaordMechanic.jsx";
import DashboardMobileUser from "./layouts/Dashboard/DashboardMobileUser.jsx";

export const hist = createBrowserHistory();
const client = new AWSAppSyncClient({
  url: config.aws_appsync_graphqlEndpoint,
  region: config.aws_appsync_region,
  disableOffline: true,
  auth: {
    type: config.aws_appsync_authenticationType,
    apiKey: config.aws_appsync_apiKey,
    jwtToken: async () =>
      (await Auth.currentSession()).getAccessToken().getJwtToken()
  }
});
const loadingDiv = {
  position: "fixed",
  zIndex: "100000",
  opacity: "0.8",
  top: "0px",
  right: "0px",
  width: "100%",
  height: "100%",
  backgroundColor: "#666",
  textAlign: "center",
  verticalAlign: "middle",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center"
};
function MyErrorBoundary(props) {
  return (
    <div>
      Some error occurred in loading application. Please check your internet
      connection or try again.
    </div>
  );
}
class App extends Component {
  state = {
    user: null,
    userAttributes: null
  };

  componentDidMount() {
    this.props.storeClient(client);
    this.getUserData();
    // Hub.listen("auth", this, "onHubCapsule");
  }

  getUserData = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      if (user) {
        this.props.storeUser(user);

        let userType = undefined;
        if (
          user.signInUserSession.idToken.payload["cognito:groups"] !== undefined
        ) {
          userType =
            user.signInUserSession.idToken.payload["cognito:groups"][0];
        }
        if (userType === "Customers") {
          const custProfile = await client.query({
            query: gql(getCustomer),
            fetchPolicy: `network-only`,
            variables: {
              id: user.username
            }
          });
          let data = custProfile.data.getCustomer;
          this.props.storeProfile(data);
        }
      }
    } catch (err) {
      this.props.storeUser("notFound");
    }
  };

  render() {
    const authProps = {
      user: this.state.user,
      setUser: this.setUser
    };
    let userType = undefined;

    if (this.props.loading === true) {
      return <h3>Loading...</h3>;
    }
    if (
      this.props.user !== null &&
      this.props.user !== undefined &&
      this.props.user !== "notFound" &&
      this.props.user.signInUserSession.idToken.payload["cognito:groups"] !==
        undefined
    ) {
      userType = this.props.user.signInUserSession.idToken.payload[
        "cognito:groups"
      ][0];
    }

    const indexRoutes = [{ path: "/", component: Dashboard }];
    const indexAdminRoutes = [{ path: "/", component: DashboardAdmin }];
    const indexInspectorRoutes = [{ path: "/", component: DashboardInspector }];
    const indexVendorRoutes = [{ path: "/", component: DashboardVendor }];
    const indexMechanicRoutes = [{ path: "/", component: DashboardMechanic }];
    const indexTireVendorRoutes = [
      { path: "/", component: DashboardTireVendor }
    ];
    const dispatcherRoutes = [{ path: "/", component: DashboardDispatcher }];
    const technicianRoutes = [{ path: "/", component: DashboardTechnician }];
    const mobileUserRoutes = [{ path: "/", component: DashboardMobileUser }];

    /////////////end ////////////////
    /*
    const Dashboard = lazy(() => import("layouts/Dashboard/Dashboard.jsx"));
    const indexRoutes = [{ path: "/", component: Dashboard }];

    const DashboardAdmin = lazy(() =>
      import("layouts/Dashboard/DashboardAdmin.jsx")
    );
    const indexAdminRoutes = [{ path: "/", component: DashboardAdmin }];

    const DashboardInspector = lazy(() =>
      import("layouts/Dashboard/DashboardInspector.jsx")
    );
    const indexInspectorRoutes = [{ path: "/", component: DashboardInspector }];
    ///////////////////////////////////////
    const DashboardVendor = lazy(() =>
      import("layouts/Dashboard/DashboardVendor.jsx")
    );
    const indexVendorRoutes = [{ path: "/", component: DashboardVendor }];

    const DashboardTireVendor = lazy(() =>
      import("layouts/Dashboard/DashboardTireVendor.jsx")
    );
    const indexTireVendorRoutes = [
      { path: "/", component: DashboardTireVendor }
    ];

    const DashboardDispatcher = lazy(() =>
      import("layouts/Dashboard/DashboardDispatcher.jsx")
    );
    const dispatcherRoutes = [{ path: "/", component: DashboardDispatcher }];

    const DashboardMobileUser = lazy(() =>
      import("layouts/Dashboard/DashboardMobileUser.jsx")
    );
    const mobileUserRoutes = [{ path: "/", component: DashboardMobileUser }];
*/
    return this.props.user === null || this.props.user === "notFound" ? (
      <div>
        <Router history={hist}>
          <div>
            <NavbarApp auth={authProps} />
            <Switch>
              <Route
                exact
                path="/"
                // render={props => <Portal {...props} auth={authProps} />}
                render={props => <LoginPage {...props} auth={authProps} />}
              />
              <Route
                exact
                path="/forgot-password"
                // render={props => <Portal {...props} auth={authProps} />}
                render={props => <ForgotPassword {...props} auth={authProps} />}
              />
              <Route
                exact
                path="/Inspector-Reg"
                render={props => (
                  <RegistrationForm {...props} auth={authProps} />
                )}
              />
              <Route
                exact
                path="/reg/:type"
                render={props => (
                  <CustomerRegistrationForm {...props} auth={authProps} />
                )}
              />
              <Route
                exact
                path="/regVendor"
                render={props => <VendorRegForm {...props} auth={authProps} />}
              />
              <Route
                exact
                path="/regTVendor"
                render={props => (
                  <TireVendorRegForm {...props} auth={authProps} />
                )}
              />
              <Route
                exact
                path="/IntroToDot"
                render={props => <IntroToDot {...props} auth={authProps} />}
              />
              <Route
                exact
                path="/Trainings"
                render={props => <Trainings {...props} auth={authProps} />}
              />
              <Route
                exact
                path="/login-page"
                render={props => <LoginPage {...props} auth={authProps} />}
              />
              <Route
                exact
                path="/Confirmation/:type"
                render={props => <ConfirmSignUp {...props} auth={authProps} />}
              />
              <Route
                exact
                path="/_Confirmation"
                render={props => <ConfirmSignUp2 {...props} auth={authProps} />}
              />
              <Route
                exact
                path="/term-page"
                render={props => <Terms {...props} auth={authProps} />}
              />
              <Route
                exact
                path="/privacy-page"
                render={props => <Privacy {...props} auth={authProps} />}
              />
              <Route
                exact
                path="/about-page"
                render={props => <About {...props} auth={authProps} />}
              />
              <Route
                exact
                path="/contact-page"
                render={props => <Contact {...props} auth={authProps} />}
              />
              <Route
                exact
                path="/vType-page"
                render={props => (
                  <VehicleTypeForm {...props} auth={authProps} />
                )}
              />
              <Route
                exact
                path="/DashboardCustomer"
                render={props => (
                  <CustomerDashboard {...props} auth={authProps} />
                )}
              />
              <Route path="*" component={LoginPage} />
            </Switch>
          </div>
        </Router>
        <Spinner name="mySpinner">
          <div style={loadingDiv}>
            <img
              src={loadingImg}
              style={{ width: "70px", height: "70px" }}
              alt="Loading..."
            />
          </div>
        </Spinner>
      </div>
    ) : (
      <ProviderContext>
        <Spinner name="mySpinner">
          <div style={loadingDiv}>
            <img
              src={loadingImg}
              style={{ width: "70px", height: "70px" }}
              alt="Loading..."
            />
          </div>
        </Spinner>
        <ApolloProvider client={client}>
          <Rehydrated>
            <Suspense fallback={<div>Loading...</div>}>
              <Router history={hist}>
                <Switch>
                  {userType !== undefined
                    ? userType === "Admin"
                      ? indexAdminRoutes.map((prop, key) => {
                          return (
                            <Route
                              path={prop.path}
                              component={prop.component}
                              key={key}
                            />
                          );
                        })
                      : userType === "Inspectors"
                      ? indexInspectorRoutes.map((prop, key) => {
                          return (
                            <Route
                              path={prop.path}
                              component={prop.component}
                              key={key}
                            />
                          );
                        })
                      : userType === "Customers"
                      ? indexRoutes.map((prop, key) => {
                          return (
                            <Route
                              path={prop.path}
                              component={prop.component}
                              key={key}
                            />
                          );
                        })
                      : userType === "Vendors"
                      ? indexVendorRoutes.map((prop, key) => {
                          return (
                            <Route
                              path={prop.path}
                              component={prop.component}
                              key={key}
                            />
                          );
                        })
                      : userType === "TireVendors"
                      ? indexTireVendorRoutes.map((prop, key) => {
                          return (
                            <Route
                              path={prop.path}
                              component={prop.component}
                              key={key}
                            />
                          );
                        })
                      : userType === "Dispatchers"
                      ? dispatcherRoutes.map((prop, key) => {
                          return (
                            <Route
                              path={prop.path}
                              component={prop.component}
                              key={key}
                            />
                          );
                        })
                      : userType === "Drivers"
                      ? mobileUserRoutes.map((prop, key) => {
                          return (
                            <Route
                              path={prop.path}
                              component={prop.component}
                              key={key}
                            />
                          );
                        })
                      : userType === "Technicians"
                      ? technicianRoutes.map((prop, key) => {
                          return (
                            <Route
                              path={prop.path}
                              history={prop.history}
                              component={prop.component}
                              key={key}
                            />
                          );
                        })
                      : userType === "TireMan"
                      ? dispatcherRoutes.map((prop, key) => {
                          return (
                            <Route
                              path={prop.path}
                              component={prop.component}
                              key={key}
                            />
                          );
                        })
                      : userType === "Mechanics"
                      ? indexMechanicRoutes.map((prop, key) => {
                          return (
                            <Route
                              path={prop.path}
                              component={prop.component}
                              key={key}
                            />
                          );
                        })
                      : null
                    : null}
                </Switch>
              </Router>{" "}
            </Suspense>{" "}
          </Rehydrated>
        </ApolloProvider>
        <ToastContainer />
      </ProviderContext>
    );
  }
}

// const theme = {
//   ...AmplifyTheme,
//   navBar: {
//     ...AmplifyTheme.navBar,
//     backgroundColor: "#ffc0cb"
//   },
//   button: {
//     ...AmplifyTheme.button,
//     backgroundColor: "var(--amazonOrange)"
//   },
//   sectionBody: {
//     ...AmplifyTheme.sectionBody,
//     padding: "5px"
//   },
//   sectionHeader: {
//     ...AmplifyTheme.sectionHeader,
//     backgroundColor: "var(--squidInk)"
//   }
// };
const mapStateToProps = state => {
  return {
    user: state.config.user,
    loading: state.config.loading,
    client: state.config.client,
    profile: state.config.profile
  };
};
const mapDispatchToProps = dispatch => {
  return {
    storeProfile: data => dispatch(actionTypes.storeProfile(data)),
    storeUser: data => dispatch(actionTypes.storeUser(data)),
    storeClient: data => dispatch(actionTypes.storeClient(data))
  };
};
export default App = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/App.js